/**
 * Static utility class for email validation
 */
export class EmailValidator {
  private static readonly EMAIL_PATTERN = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  );

  /**
   * Validates if the given string matches a valid email pattern.
   * Returns true for empty/null/undefined values (use required validation separately).
   * @param email - The email string to validate
   * @returns true if email is valid or empty, false otherwise
   */
  static isValidPattern(email: string | null | undefined): boolean {
    if (!email) return true;
    return this.EMAIL_PATTERN.test(email);
  }
}
